const stats = [
  { value: '12', suffix: '个方向', label: '持续更新的话题线' },
  { value: '每日', suffix: '更新', label: '热点当天补充进展' },
  { value: '4', suffix: '大分类', label: '娱乐 / 社会 / 职场 / 生活' },
  { value: '100%', suffix: '人工', label: '时间线整理与核对' },
];

const quotes = [
  {
    text: '以前刷半天也不知道事情来龙去脉，看料99 一条时间线就讲清楚了，省了很多时间。',
    name: '林晓',
    role: '互联网运营',
  },
  {
    text: '职场的几篇写得很实在，没什么废话，看完能直接对照自己的情况。',
    name: '陈默',
    role: '产品经理',
  },
  {
    text: '订阅之后只在重要更新时收到邮件，没有乱七八糟的广告，这点很难得。',
    name: '苏芮',
    role: '自由设计师',
  },
];

export default function BrandBand() {
  return (
    <section aria-label="品牌介绍与口碑" className="mx-auto mt-16 w-full max-w-[1280px] px-4 md:mt-20 md:px-6">
      <div className="rounded-lg bg-secondary-800 p-6 text-background-100 md:p-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.2fr]">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-accent-300">
              <span className="h-1 w-6 rounded-full bg-accent-400" aria-hidden="true"></span>
              关于 看料99
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              让每一条消息，都能被读懂
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              看料99 不做标题党，也不把传闻当成结论。我们把散落的信息按时间线重新排列，
              标注清楚哪些已经确认、哪些仍待核实，让你看完能形成自己的判断。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-md bg-secondary-700 p-4">
                  <p className="font-heading text-xl font-bold text-background-50">
                    {s.value}
                    <span className="ml-1 text-xs font-normal text-accent-300">{s.suffix}</span>
                  </p>
                  <p className="mt-1 text-xs text-background-400">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {quotes.map((q) => (
              <blockquote
                key={q.name}
                className="rounded-lg border border-secondary-700 bg-secondary-900/60 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-accent-400" aria-hidden="true"></i>
                <p className="mt-2 text-sm leading-relaxed text-background-200">{q.text}</p>
                <footer className="mt-3 flex items-center gap-2 text-xs text-background-400">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-700 text-background-200">
                    <i className="ri-user-3-line" aria-hidden="true"></i>
                  </span>
                  {q.name} · {q.role}
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}